module.exports = __webpack_public_path__ + "static/media/tradie.0d332c34.png";